export interface Bloco {
  id: number;
  nome: string;
  blocos: string;
}

export type BlocoPayload = Omit<Bloco, "id">;

export type BlocoFormErrors = Partial<Record<keyof BlocoPayload, string>>;

export interface BlocosApiResponse {
  success: boolean;
  data: Bloco[];
}

export const BLOCO_FIELDS: Array<keyof BlocoPayload> = ["nome", "blocos"];

export const emptyBloco: BlocoPayload = {
  nome: "",
  blocos: "",
};
